// @flow

import type { FeatureFlags, InsuranceType } from '../types';

// eslint-disable-next-line complexity
export const journeyEnabled = (featureFlags: ?FeatureFlags) => (
  insuranceType: InsuranceType
): boolean => {
  if (!featureFlags) {
    return false;
  }
  switch (insuranceType) {
    case 'car':
      return featureFlags.motor_enabled;
    case 'home':
      return featureFlags.home_enabled;
    case 'travel':
      return featureFlags.travel_enabled;
    default:
      return false;
  }
};
